export default "__VITE_ASSET__KUa_QijB__"